import { render, staticRenderFns } from "./StoreCorporationDetail.vue?vue&type=template&id=e19fff36&scoped=true&"
import script from "./StoreCorporationDetail.vue?vue&type=script&lang=js&"
export * from "./StoreCorporationDetail.vue?vue&type=script&lang=js&"
import style0 from "./StoreCorporationDetail.vue?vue&type=style&index=0&id=e19fff36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e19fff36",
  null
  
)

export default component.exports